/***
 *
 *   HOME NAV
 *   Navigation used on the main external website. Renders a dashboard link
 *   if the user is signed in, or a sign up link if they are not
 *
 **********/

import { AuthContext, ClassHelper } from "components/lib";
import { useContext, useEffect } from "react";
import Style from "./home.module.scss";
import Logo from "./images/DefaultLogo.png";

export function HomeNav(props) {
  const css = ClassHelper(Style, {
    wrapper: true,
    color: !props.transparent,
    transparent: props.transparent,
  });

  return (
    <section className={css}>
      <img src={Logo} alt="Logo" className={Style.logo} />
    </section>
  );
}
